module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.files) ? _c('div', [_c('label', {
    attrs: {
      "for": "selectedFileName"
    }
  }, [_vm._v("Filename")]), _vm._v(" "), _c('label', {
    staticClass: "form-control",
    attrs: {
      "id": "selectedFileName",
      "disabled": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.getSelectedFileName()) + " ")]), _vm._v(" "), _c('file-upload', {
    ref: "upload",
    staticClass: "btn btn-primary",
    attrs: {
      "post-action": _vm.getPostAction(),
      "multiple": false,
      "drop": true,
      "drop-directory": true,
      "id": "fileUpload"
    },
    on: {
      "input-file": _vm.inputFile
    },
    model: {
      value: (_vm.files),
      callback: function($$v) {
        _vm.files = $$v
      },
      expression: "files"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("\n                Select file\n                ")]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "ModelNameEdit"
    }
  }, [_vm._v("Model Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.name),
      expression: "value.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.isBusy,
      "id": "ModelNameEdit",
      "placeholder": "Enter model name",
      "required": ""
    },
    domProps: {
      "value": (_vm.value.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "DescriptionEdit"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.description),
      expression: "value.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "DescriptionEdit",
      "disabled": _vm.isBusy,
      "placeholder": "Enter model description",
      "required": ""
    },
    domProps: {
      "value": (_vm.value.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "categoryEdit"
    }
  }, [_vm._v("Category")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.category),
      expression: "value.category"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.isBusy,
      "id": "categoryEdit",
      "placeholder": "Enter model category",
      "required": ""
    },
    domProps: {
      "value": (_vm.value.category)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "category", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.files.length == 0
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$refs.upload.active = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-up",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                    Upload\n                ")])])], 1) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-83db0670", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83db0670"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/upload-model-dialog/upload-model-dialog.vue.html
// module id = 1123
// module chunks = 0